/**
 * User-facing copy for the .fitpack import flow. Shared by every entry point
 * that can stage a shared collection — the in-app file picker (MenuComponent)
 * and the OS "open .fitpack" handler (FitpackOpenService) — so the wording
 * stays identical no matter how the file arrives.
 */
export enum ImportMessage {
  AlertHeader = 'Import .fitpack',
  SignInToImport = 'Sign in or create a free account to import this shared collection.',
  OpenFailed = 'Failed to open .fitpack',
  InvalidStructure = 'Invalid .fitpack: invalid manifest structure',
}
